import { ChildrenProps, IconSize } from 'styled-system';

export enum NotificationIntent {
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
}

export type NotificationProps = {
  intent?: NotificationIntent;
  iconSize?: keyof IconSize;
} & ChildrenProps;

export type IconStyledProps = { intent: NotificationIntent };
export type TextStyledProps = { intent: NotificationIntent };
